'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _PortfolioGallery = require('./PortfolioGallery/PortfolioGallery');var _PortfolioGallery2 = _interopRequireDefault(_PortfolioGallery);

var _containers = require('../../containers');

var _Portfolio = require('./Portfolio.scss');var styles = _interopRequireWildcard(_Portfolio);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Containers
// Modules

var Portfolio = function Portfolio(props) {
  var renderLightbox = function renderLightbox() {
    var images = (0, _get2.default)(props, 'images') || [];

    return (
      _react2.default.createElement(_containers.OMLightbox, {
        currentImage: props.currentImage || 0,
        changeLightboxActiveSlide: props.changeLightboxActiveSlide,
        translate: props.translate,
        images: images,
        isOpen: !props.isDetailsModalOpen && props.isOpen,
        hideLightbox: props.hideLightbox,
        locale: props.locale,
        isRtl: props.isRtl }));


  };

  return (
    _react2.default.createElement('div', { className: styles.portfolioWrapper },
      _react2.default.createElement('div', { className: styles.title },
        props.portfolioTitle),

      _react2.default.createElement(_PortfolioGallery2.default, {
        images: props.images,
        openLightbox: props.openLightbox }),

      renderLightbox()));


}; // Styles
// Components
Portfolio.propTypes = {
  images: _propTypes2.default.array,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  portfolioTitle: _propTypes2.default.func,
  currentImage: _propTypes2.default.number,
  locale: _propTypes2.default.string,
  isOpen: _propTypes2.default.bool,
  isDetailsModalOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };exports.default =


Portfolio;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Portfolio/Potrfolio.js
// module id = 2780
// module chunks = 0